import React, { forwardRef, useImperativeHandle } from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

// Assign fonts
pdfMake.vfs = pdfFonts.vfs;

const Inscanpdf = forwardRef(({ state }, ref) => {
  const pickup = state?.PickupDetails?.[0] || {};
  const customer = pickup?.Consigner?.[0] || {};
  const consignee = pickup?.Consignee?.[0] || {};
  const pkg = pickup?.PackageDetails?.[0] || {};

  const generatePDF = () => {
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [20, 20, 20, 30],
      content: [
        // Header with logo and title
        {
          columns: [
            { image: 'logo', width: 60 },
            {
              width: '*',
              text: 'LA LOGISTICS PRIVATE LIMITED',
              style: 'header',
              alignment: 'center',
              margin: [0, 15, 0, 0],
            },
            {
              text: '',
              width: 60,
            },
          ],
        },
        {
          text: `${pickup?.Origin?.toUpperCase()} - ${pickup?.Destination?.toUpperCase()}`,
          alignment: 'center',
          margin: [0, 10, 0, 10],
          bold: true,
        },

        // Manifest & Docket Info
        {
          columns: [
            {
              width: '50%',
              stack: [
                { text: `Manifest: ${state?.ManifestId || ''}` },
                { text: `Dispatch From: ${pickup?.Origin || ''}` },
                { text: `Mode Type: ${state?.ModeType || ''}` },
                {
                  text: `Master AWB Date: ${
                    pickup?.updatedAt ? moment(pickup.updatedAt).format('DD-MM-YYYY HH:mm:ss') : '-'
                  }`,
                },
                {
                  text: `Master AWB Weight: ${pickup?.totalVolumetrix?.toFixed(3) || ''}`,
                },
              ],
              margin: [0, 0, 0, 10],
              fontSize: 9,
            },
            {
              width: '50%',
              stack: [
                { text: `Manifest Date: ${moment(state?.createdAt).format('DD-MM-YYYY')}` },
                { text: `Time: ${moment(state?.createdAt).format('HH:mm')}` },
                { text: `Dispatch To: ${pickup?.Destination || ''}` },
                {
                  text: `Mode Name: ${
                    state?.ModeType === 'AIR'
                      ? state?.AirDetails?.[0]?.FlightNumber
                      : state?.ModeType === 'ROAD'
                      ? state?.RoadDetails?.[0]?.VehicalType
                      : state?.TrainDetails?.[0]?.TrainName || ''
                  }`,
                },
                {
                  text: `Master AWB: ${state?.PickupDetails?.map(p => p.DocketId).join(', ') || ''}`,
                },
                { text: `Master AWB Pkgs: ${pickup?.totalPkg || ''}` },
              ],
              fontSize: 9,
            },
          ],
        },

        {
          text: 'Docket Details',
          style: 'subheader',
          margin: [0, 10, 0, 5],
        },

        // Docket Table
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'No.', bold: true },
                { text: 'Docket ID', bold: true },
                { text: 'Origin', bold: true },
                { text: 'Destination', bold: true },
                { text: 'Consigner', bold: true },
                { text: 'Consignee', bold: true },
                { text: 'Packages', bold: true },
                { text: 'Weight', bold: true },
                { text: 'Remarks', bold: true },
              ],
              ...(state?.PickupDetails || []).map((item, idx) => [
                idx + 1,
                item.DocketId,
                item.Origin,
                item.Destination,
                item.ConsignerName,
                item.ConsigneeName,
                item.totalPkg,
                item.totalVolumetrix,
                item.Remark || '',
              ]),
              [
                { colSpan: 6, text: 'Total', bold: true },
                {},
                {},
                {},
                {},
                {},
                {
                  text: state?.PickupDetails?.reduce((acc, cur) => acc + (cur.totalPkg || 0), 0),
                  bold: true,
                },
                {
                  text: state?.PickupDetails
                    ?.reduce((acc, cur) => acc + (cur.totalVolumetrix || 0), 0)
                    .toFixed(3),
                  bold: true,
                },
                '',
              ],
            ],
          },
          fontSize: 8,
          layout: 'lightHorizontalLines',
        },

        // Footer
        {
          columns: [
            {
              text: `Prepared By: ${state?.LoadingPerson || 'N/A'}`,
              fontSize: 9,
              margin: [0, 20, 0, 0],
            },
            {
              text: `Dispatch Manager:`,
              fontSize: 9,
              alignment: 'right',
              margin: [0, 20, 0, 0],
            },
          ],
        },
        {
          text: 'ALL DISPUTES ARE SUBJECT TO BHIWANDI JURISDICTION',
          alignment: 'center',
          fontSize: 9,
          bold: true,
          margin: [0, 20, 0, 0],
        },
      ],
    //   images: {
    //     // Replace below with actual base64 string of your image
    //     logo:
    //      'https://arrowcon.azurewebsites.net/images/LALogistic-1.png',
    //   },
    //   styles: {
    //     header: { fontSize: 12, bold: true },
    //     subheader: { fontSize: 10, bold: true, decoration: 'underline' },
    //   },
    };

    pdfMake.createPdf(docDefinition).open();
  };

  useImperativeHandle(ref, () => ({
    generatePDF,
  }));

  return <div style={{ display: 'none' }}>PDF Generator</div>;
});

export default Inscanpdf;
